import React, { Component } from "react"
// import { BrowserRouter, Link } from 'react-router-dom';
import axios from "axios"
import { extractRemoteMarkup } from "../utils/remoteMarkup"

export class Footer extends Component {
	state = {
		nav1: [],
		nav2: [],
		social: [],
		remoteFooter: null
	}

	getYear = () => {
		return new Date().getFullYear()
	}
	componentDidMount() {
		axios({
			url: "https://www.usa.edu",
			auth: {
				username: "usahs",
				password: "usahsMarketing"
			}
		})
			.then((resp) => {
				const remoteFooter = extractRemoteMarkup(resp.data, "footer.footer")

				if (remoteFooter) {
					this.setState({
						remoteFooter: remoteFooter.replaceAll("fa fa", "fab fa")
					})
				}
			})
			.catch((error) => {
				console.log(error)
			})
	}

	render() {
		const { remoteFooter } = this.state

		return (
			<>
				<div dangerouslySetInnerHTML={{ __html: remoteFooter }} />
			</>
		)
	}
}

export default Footer
